/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useCallback, useEffect, useState } from 'react';
import { Button, Modal, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { ColumnTitle } from 'antd/lib/table/interface';
import SortableList from '@components/SortableList';

interface IModalSelectColumnsProps {
  visible: boolean;
  onClose?: () => void;
  columns: {
    title?: ColumnTitle<any>;
    visible: boolean;
  }[];
  updateColumns: (newColumns: any) => void;
}

const ModalSelectColumns = ({
  visible,
  onClose = () => {},
  columns,
  updateColumns,
}: IModalSelectColumnsProps) => {
  const { t } = useTranslation('table');

  const [saveLoading, setSaveLoading] = useState(false);
  const [listSwitch, setListSwitch] = useState(columns);

  useEffect(() => {
    setListSwitch(columns);
  }, [columns]);

  const onFinish = useCallback(() => {
    setSaveLoading(true);
    updateColumns(listSwitch);
    setSaveLoading(false);
    onClose();
  }, [listSwitch, updateColumns, onClose]);

  const handleListChange = useCallback((newList: any) => {
    setListSwitch(newList);
  }, []);

  const handleClose = useCallback(() => {
    setListSwitch(columns);
    onClose();
  }, [columns, onClose]);

  const handleListItemChange = useCallback(
    (indexToChange: number) => {
      setListSwitch([
        ...listSwitch.map((item, indexItem) =>
          indexItem === indexToChange
            ? { ...item, visible: !item.visible }
            : item,
        ),
      ]);
    },
    [listSwitch],
  );

  return (
    <Modal
      bodyStyle={{ minHeight: 200 }}
      footer={
        <>
          <Button onClick={() => onClose()}>{t('buttons.cancel')}</Button>
          <Button loading={saveLoading} type="primary" onClick={onFinish}>
            {t('buttons.save')}
          </Button>
        </>
      }
      okButtonProps={{ form: 'customerForm', htmlType: 'submit' }}
      style={{ maxWidth: 900 }}
      title={t('columns-settings')}
      open={visible}
      width="70%"
      centered
      onCancel={handleClose}
      afterClose={() => document.body.style.removeProperty('overflow')}
    >
      <Row>
        <SortableList
          items={listSwitch}
          onChange={handleListChange}
          switchItemChange={handleListItemChange}
        />
      </Row>
    </Modal>
  );
};

ModalSelectColumns.defaultProps = {
  onClose: () => {},
};

export default ModalSelectColumns;
